import { Skeleton } from '@/components/ui/Skeleton';
import { useEquipmentFileUrl } from '@/features/equipment/hooks';
import { EQUIPMENT_CATEGORY_META, isEquipmentCategory } from '@/features/equipment/model';
import { cn } from '@/lib/utils';
import { Forklift } from 'lucide-react';

const SIZE_CLASS = {
  sm: 'h-8 w-8',
  md: 'h-11 w-11',
} as const;

/**
 * Square cover photo for list rows. Falls back to the category icon so
 * rows without a photo still line up.
 */
export function EquipmentThumbnail({
  imagePath,
  category,
  size = 'sm',
}: {
  imagePath: string | null;
  category: string;
  size?: keyof typeof SIZE_CLASS;
}) {
  const { data: url, isLoading } = useEquipmentFileUrl(imagePath);
  const box = SIZE_CLASS[size];

  if (!imagePath) {
    const Icon = isEquipmentCategory(category) ? EQUIPMENT_CATEGORY_META[category].icon : Forklift;
    return (
      <div
        className={cn(
          'flex shrink-0 items-center justify-center rounded-md border border-border bg-secondary/30 text-muted-foreground',
          box,
        )}
        aria-hidden
      >
        <Icon className="h-4 w-4" strokeWidth={1.6} />
      </div>
    );
  }
  if (isLoading || !url) return <Skeleton className={cn('shrink-0 rounded-md', box)} />;
  return (
    <img
      src={url}
      alt=""
      loading="lazy"
      className={cn('shrink-0 rounded-md border border-border bg-secondary/30 object-cover', box)}
    />
  );
}
